import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

/**
 * Inverso de authGuard: si ya hay sesión activa, no tiene sentido dejar ver
 * /login de nuevo (LOGIN-05) — se manda directo a /dashboard. Se aplica solo
 * a la ruta 'login', no a forgot-password/reset-password (no reportado ni
 * pedido para esas dos).
 */
export const guestGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) return true;
  return router.createUrlTree(['/dashboard']);
};
